module.exports = "<!---start preloader-->\r\n<div  id=\"verify_email_preloader\">\r\n    <div id=\"loader\"></div>\r\n</div>\r\n<!--end preloader-->"